import { Navigate } from "react-router-dom";
import { UserConfigContext } from "../context/UserConfigContext";
import { useState, useEffect,useContext } from "react";

const ProtectedRoute = ({ element }) => {

  const { config1, config2 } = useContext(UserConfigContext);

  const user = JSON.parse(localStorage.getItem("user")); // Obtener el usuario del localStorage

  // Mientras la config se carga
  if (config2 === null) {
    return null; // o un loading spinner
  }

  if (config2?.vista?.login === 0) {
    return element;
  } else if (user) {
    return element;
  } else {
    return <Navigate to="/signin" />;
  }
};

export default ProtectedRoute;
